/**
 * Benachrichtigungen — nur noch eine Weiterleitung.
 *
 * Die Seite selbst liegt seit dem 01.09. in `account-web` und ist unter
 * konto.elbklar.com erreichbar. Die Einstellungen haengen an `users.id` in
 * einer gemeinsamen Datenbank: was hier gesetzt wurde, galt immer schon auch
 * im pm. Zwei Oberflaechen dafuer zu pflegen hiesse, zwei Kopien derselben
 * Sache auseinanderlaufen zu lassen.
 *
 * Die Route bleibt bestehen, weil sie in der Sidebar, in Lesezeichen und in
 * `action_url` aelterer Benachrichtigungen steht. Wer sie aufruft, landet
 * dort, wo die Seite heute wohnt — mit einem Weg zurueck.
 */

import { useEffect } from 'react';
import { Bell } from 'lucide-react';
import { kontoUrl } from '@/lib/konto';

export function NotificationSettingsPage() {
  // Der Weg zurueck fuehrt aufs Dashboard, nicht auf diese Seite — sonst
  // schickte der Rueckweg einen sofort wieder hierher und von hier wieder weg.
  const ziel = kontoUrl('/benachrichtigungen', `${window.location.origin}/dashboard`);

  useEffect(() => {
    // `replace`, damit der Zurueck-Knopf des Browsers nicht wieder hier
    // landet und sofort erneut weiterleitet.
    window.location.replace(ziel);
  }, [ziel]);

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <Bell size={30} strokeWidth={1.5} className="mb-4 text-muted-foreground" aria-hidden />
      <p className="text-muted-foreground">
        Die Benachrichtigungs-Einstellungen sind umgezogen.
      </p>
      <a
        href={ziel}
        className="mt-2 font-medium text-link hover:underline"
      >
        Weiter zu konto.elbklar.com
      </a>
    </div>
  );
}
